/* eslint-disable camelcase */
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { loadJS } from 'utils/loadPlayerJSFiles';
import { getPlayerUrl, logPerformanceTime } from './helper';

// Track initialized players by their unique combination of divId and slikeId
const initializedPlayers = new Set();

export function playerloadError(e) {
  let label = '';
  try {
    label = JSON.stringify(e);
  } catch (error) {
    label = 'player_not_found';
  }
  analyticsWrapper('ga4', {
    event: 'user_shown',
    type: 'light_player_load_error',
    label,
  });
}
// eslint-disable-next-line import/prefer-default-export
export function loadLitePlayerJSFiles(pageProps, cb) {
  const url = getPlayerUrl(pageProps);
  loadJS(url, 'light_tvid_sdk_js', 'CleoPlayer', true)
    .then(cb)
    .catch(playerloadError);
}

function generatepageTpl(props, tmpl, scn) {
  try {
    const { tplId, tplPos, tplSecFlag } = props;
    const parts = [];
    if (tplId) parts.push(tplId);
    if (tmpl) parts.push(tmpl);
    if (tplSecFlag && scn) parts.push(scn);
    if (tplPos) parts.push(tplPos);
    return parts.join('_').toLowerCase();
  } catch (error) {
    return tmpl;
  }
}
export function setSlikeConfig(props, pageProps) {
  const { divId, slikeId: id } = props;
  const playerKey = `${divId}_${id}`;

  if (
    !(
      props?.globalRefId === 'minitv' ||
      props?.globalRefId_game === 'locationguesser' ||
      props?.globalRefId === 'lg_rhsvideowidget'
    )
  ) {
    // Skip if this specific player is already initialized
    if (initializedPlayers.has(playerKey)) {
      return null;
    }
    // Mark this player as initialized
    initializedPlayers.add(playerKey);
  }

  const getCustumparams = adsKeys => {
    const keys = ['Meta_Keywords', 'BL'];
    const result = {};
    Object.keys(adsKeys).forEach(key => {
      if (!keys.includes(key)) {
        result[key] = adsKeys[key];
      }
    });
    return result;
  };

  const {
    isPrime,
    mute,
    autoPlay, // 2(ALLOWED), 1(WITH_MUTE), 0(NOT_ALLOWED)
    shareUrl,
    isVideoSkipAds,
    headless,
    sectionName,
    metakeywords,
    bl: BL,
    sg,
    skipAnalytics,
    skipMultiInstance,
    fgResume,
    videoInloop,
    defaultVolume,
    midfreq,
    playInBackground,
    config = {},
    pageTpl,
    ui,
    msid,
    recoConfig,
    playerType,
    splId,
    getDockViewUI,
    isInline,
    isWapView,
    gestureControls,
    isEtimes,
    isV4DockingEnabled,
  } = props;
  const adSection = props.newGamAdSection || sectionName || props.adSection;
  const { apiKey } = pageProps;
  const pageKeys = window?.Times?.adsKeys || {};
  const customparams = getCustumparams(pageKeys);
  const { Tmpl_SCN: tmpl, SCN: pageSection, Hyp1: specialId } = pageKeys;
  let skipAd = isVideoSkipAds;
  if (isPrime || specialId === 'noad') {
    skipAd = true;
  }
  const sgFromCookies =
    window?._dfpObj?.getCcaudData && window._dfpObj.getCcaudData();

  const dockTopPosition = isInline ? 34 : 34;

  const newPageTpl = pageTpl || generatepageTpl(props, tmpl, pageSection);

  let GDPR_MODE = false;
  if (
    window &&
    window.TimesGDPR &&
    window.TimesGDPR.common &&
    window.TimesGDPR.common.consentModule
  ) {
    let isEUuser = window.TimesGDPR.common.consentModule.isEUuser(true);
    // This is a fallback for the case when the GDPR cookie is not set. In that case, no personlisation to avoid legal issues.
    if (isEUuser === undefined) {
      isEUuser = true;
    }
    GDPR_MODE = isEUuser;
  }
  const returnConfig = {
    id,
    el: document.getElementById(divId),
    apiKey,
    controls: !headless,
    autoPlay: autoPlay === 0 ? 0 : autoPlay || 2,
    mute: typeof mute === 'undefined' ? true : mute,
    playerType: playerType || '',
    gestureControl: gestureControls,
    skipModule: {
      skipAd,
      skipAnalytics,
      skipMultiInstance:
        typeof skipMultiInstance === 'undefined' ? false : skipMultiInstance, // Added to prevent multiple instances of the player on a page
      ...config.skipModule,
    },
    msid,
    recoConfig,
    ui: ui || { scale: 1 },
    analytics: {
      gdpr: GDPR_MODE,
      pageSection,
      isPrime,
      pageUrl: window?.location?.href,
      pageTpl: newPageTpl,
      ...config.analytics,
    },
    lbandonIsv: true,
    callbacks: {
      onPlayerConfig: () => {
        const object = {
          ads: {
            adSection,
            preRollAdFiller: {
              enable: true,
              time: 7,
            },
            midfreq, //midRollAdBreak
            //  deferredPreroll: 7, will delay by this time
            params: {
              Meta_Keywords: metakeywords || pageKeys.Meta_Keywords,
              BL: typeof BL !== 'undefined' ? BL : pageKeys.BL,
              sg: sg || sgFromCookies,
              custom_params: {
                ...customparams,
                Hyp1: splId || specialId,
                ...config.adparams,
              },
            },
            ...config.onAdplayer,
          },
          player: {
            fgResume: typeof fgResume === 'undefined' ? false : fgResume, // Added to stop the resume in case of tab change and video is in viewport less than 50%
            iosNativeFs: true, // Added to enable the native fullscreen on ios
            lbandonIsv: false,
            autoPlay,
            mute,
            isPrime,
            volume: defaultVolume || 70,
            shareUrl,
            loop: videoInloop,
            scroll: {
              view: 50,
              multiplay: isV4DockingEnabled ? undefined : false,
            },
            // scrollBehaviour, not now
            // gestureControls, noot now
            playInBackground,
            dock:
              isV4DockingEnabled && isWapView
                ? {
                    dockType: 'custom',
                    dockLeft: 0,
                    dockTop: isEtimes ? '0' : dockTopPosition,
                    width: '300',
                    scrollDock: true,
                    htmlContent: getDockViewUI,
                    animateDock: false,
                  }
                : {},
            ...config.onPlayer,
          },
        };
        return object;
      },
      onAdsCall: () => ({ headerbiding: true }),
      onAdsConfig: () => ({
        ...(window?.adsconfig?.slikeAdConfig || {}),
        ...config.onAdsConfig,
      }),
    },
    ...config.root,
  };
  return returnConfig;
}

const playerEventTypeMap = {
  cplVideoEnded: 'VIDEOENDED',
  cplVideoCompleted: 'VIDEOCOMPLETE',
  cplPlayerReady: 'INIT',
  cplVideoStarted: 'VIDEOVIEW',
  cplVideoPaused: 'VIDEOPAUSED',
  cplVideoResumed: 'VIDEORESUMED',
  cplVideoMuted: 'VIDEOMUTE',
  cplVideoUnMuted: 'VIDEOUNMUTE',
};

const adEventTypeMap = {
  cplAdComplete: 'ADCOMPLETE',
  cplAdSkip: 'ADSKIP',
  cplAdStart: 'ADSTART',
  cplAdPause: 'ADPAUSED',
  cplAdResume: 'ADRESUMED',
  cplAdUnMuted: 'VIDEOUNMUTE',
  cplAdMuted: 'VIDEOMUTE',
};

const processVideoEvent = (event, globalRefId) => {
  try {
    switch (event) {
      case 'VIDEORESUMED':
      case 'ADRESUMED':
        if (window.player?.length) {
          window.player.forEach(el => {
            if (el?.pause) el.pause();
          });
        }
        break;
      // eslint-disable-next-line no-case-declarations
      case 'INIT':
        logPerformanceTime('INIT ');
        if (globalRefId === 'minitv' && window?.lwPlayer?.minitv) {
          window.lwPlayer.minitv.play();
        }
        break;
      default:
        break;
    }
  } catch (e) {
    //
  }
};

export function attachEventsToJS(player, globalRefId, config) {
  const globalVar = window?.lwObj && window.lwObj[globalRefId];
  function eventToFunction(eventName) {
    const mapEvent = playerEventTypeMap[eventName] || adEventTypeMap[eventName];
    if (typeof config?.outsideEventListener === 'function' && mapEvent) {
      config.outsideEventListener(mapEvent, player);
      processVideoEvent(mapEvent, globalRefId);
    }
  }
  if (globalVar) {
    if (globalVar?.eventQueue?.length) {
      globalVar.eventQueue.forEach(eventName => {
        eventToFunction(eventName);
      });
      globalVar.eventQueue = [];
    }
    globalVar.eventCallback = eventToFunction.bind(null);
  }
}

export function handleEvents(player, events, config) {
  function eventToFunction(eventName) {
    const mapEvent = playerEventTypeMap[eventName] || adEventTypeMap[eventName];
    if (typeof config?.outsideEventListener === 'function' && mapEvent) {
      config.outsideEventListener(mapEvent, player);
      processVideoEvent(mapEvent);
    }

    // Add GA4 event tracking for key player events
    if (mapEvent) {
      const ga4EventMap = {
        VIDEOVIEW: {
          event: 'video_show',
          status: 'success',
          // type: 'video_play',
          // category: 'video_player',
        },
        VIDEOPAUSED: {
          event: 'user_click',
          type: 'video_pause',
          category: 'video_player',
        },
        VIDEORESUMED: {
          event: 'user_click',
          type: 'video_resume',
          category: 'video_player',
        },
        VIDEOCOMPLETE: {
          event: 'user_click',
          type: 'video_complete',
          category: 'video_player',
        },
        VIDEOMUTE: {
          event: 'user_click',
          type: 'video_mute',
          category: 'video_player',
        },
        VIDEOUNMUTE: {
          event: 'user_click',
          type: 'video_unmute',
          category: 'video_player',
        },
        ADSTART: {
          event: 'user_click',
          type: 'ad_start',
          category: 'video_player',
        },
        ADCOMPLETE: {
          event: 'user_click',
          type: 'ad_complete',
          category: 'video_player',
        },
        ADSKIP: {
          event: 'user_click',
          type: 'ad_skip',
          category: 'video_player',
        },
      };

      const ga4Event = ga4EventMap[mapEvent];
      if (ga4Event) {
        analyticsWrapper('ga4', {
          ...ga4Event,
          video_template: config?.tmplSource || 'N/A',
        });
      }
    }
  }
  Object.keys(events).forEach(eventKey => {
    const eventName = events[eventKey];
    player.on(eventName, eventToFunction.bind(null));
  });
}

export function playerErrorCallback(error, config) {
  if (typeof config?.playerErrorCallback === 'function') {
    config.playerErrorCallback(error);
  }
}

export function playNextVideo(playerId, videoId) {
  try {
    if (window?.lwPlayer?.[playerId]?.controller?.playNextVideo) {
      window.lwPlayer[playerId].controller.playNextVideo(videoId);
    }
  } catch (error) {
    console.error('Error playing next video:', error);
  }
}

export function unDockPlayer(playerId) {
  // console.log('unDockPlayer:', playerId);
  try {
    if (typeof window?.lwPlayer?.[playerId]?.unDock === 'function') {
      window.lwPlayer[playerId].unDock();
    }
  } catch (error) {
    console.error('Error undocking player:', error);
  }
}

export function isPlayerDocked(playerId) {
  try {
    if (window?.lwPlayer?.[playerId]?.ui) {
      return window.lwPlayer[playerId].ui.isDocked;
    }
    return false;
  } catch (error) {
    console.error('Error checking if player is docked:', error);
    return false;
  }
}
